// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".translucent[data-v-83d00a58]{background-color:hsla(0,0%,100%,.95);border-radius:15px}", ""]);
// Exports
module.exports = exports;
